import { Contact } from '@features/contacts/types/contact'
import { TaxRate } from '@modules-deprecated/app/taxrates/types'

export const getTaxRateFromContact = (taxRates: TaxRate[], contact?: Partial<Contact>): TaxRate | undefined => {
  if (!contact || !contact.defaultTaxRateId) {
    return
  }

  return taxRates.find(({ id }) => id === contact.defaultTaxRateId)
}
